/* VanillaGoods My Kitchen: the site's saved lists (recipe hearts, favorite markets, saved events, Academy saves and
   progress, saved products) live in this browser as before. For signed-in members they are also kept on their
   account, through the sync service, so they follow them to every device. Loaded without defer at the end of the
   page so it runs before the segment scripts read their lists. */
(function () {
  if (window.vgMe) return;

  var KEYS = ['vg_blog_favs', 'vg_fm_favorites_v1', 'vg_events_saved_v1', 'vga-saved-v1', 'vga-progress-v1', 'vg_products_saved_v1', 'vg_books_saved_v1', 'vg_bakes_v1', 'vg_plan_v1', 'vg_tools_saved_v1', 'vg_follows_v1', 'vg_desserts_v1', 'vg_baskets_v1', 'vg_bakebudget_v1'];
  var NUDGE_KEYS = ['vg_blog_favs', 'vg_fm_favorites_v1', 'vg_events_saved_v1', 'vga-saved-v1', 'vg_products_saved_v1', 'vg_books_saved_v1', 'vg_bakes_v1', 'vg_tools_saved_v1', 'vg_desserts_v1'];
  var PRODUCTS = 'vg_products_saved_v1', BOOKS = 'vg_books_saved_v1', META = 'vg_me_meta', OWNER = 'vg_me_owner';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('vg-me-data').textContent) || {}; } catch (e) { cfg = {}; }
  var ls = null;
  try { ls = window.localStorage; ls.getItem(OWNER); } catch (e) { ls = null; }
  var proto = window.Storage && window.Storage.prototype;
  var rawSet = proto && proto.setItem, rawRemove = proto && proto.removeItem;
  var syncing = !!(cfg.signedIn && cfg.endpoint && ls);
  var applying = false, listeners = [];

  function read(k) {
    if (!ls) return null;
    try { var v = ls.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function write(k, v) {
    if (!ls) return;
    applying = true;
    try { if (v == null) rawRemove.call(ls, k); else rawSet.call(ls, k, JSON.stringify(v)); } catch (e) { /* storage full or blocked */ }
    applying = false;
  }
  function empty(v) {
    if (v == null) return true;
    if (Array.isArray(v)) return !v.length;
    return typeof v === 'object' && !Object.keys(v).length;
  }
  function snapshot() {
    var o = {};
    KEYS.forEach(function (k) { var v = read(k); if (!empty(v)) o[k] = v; });
    return o;
  }
  /* Union of the account's list and this browser's list; the account's copy of an entry wins. */
  function mergeVal(a, b) {
    if (Array.isArray(a) || Array.isArray(b)) {
      var out = (a || []).slice();
      (b || []).forEach(function (x) { if (out.indexOf(x) === -1) out.push(x); });
      return out;
    }
    var o = {};
    [a || {}, b || {}].forEach(function (src) {
      Object.keys(src).forEach(function (k) { if (!Object.prototype.hasOwnProperty.call(o, k)) o[k] = src[k]; });
    });
    return o;
  }
  function mergeAll(a, b) {
    var o = {};
    KEYS.forEach(function (k) { var v = mergeVal(a[k], b[k]); if (!empty(v)) o[k] = v; });
    return o;
  }
  function applyLocal(data) { KEYS.forEach(function (k) { write(k, empty(data[k]) ? null : data[k]); }); }
  function same(a, b) { return JSON.stringify(a) === JSON.stringify(b); }

  function notify() {
    listeners.forEach(function (fn) { try { fn(); } catch (e) { /* listener error */ } });
    try { window.dispatchEvent(new CustomEvent('vgme:change')); } catch (e) { /* old browser */ }
  }

  /* ---------- account sync ---------- */
  var PEND = 'vg_me_pending_' + cfg.cid, DEVICE = 'vg_me_device_' + cfg.cid;
  var meta = (cfg.saved && cfg.saved.meta) || read(META) || {};
  var timer = null, inflight = false, again = false;

  function schedulePush() {
    if (!syncing) return;
    clearTimeout(timer);
    timer = setTimeout(push, 900);
  }
  function push() {
    if (inflight) { again = true; return; }
    inflight = true;
    var payload = JSON.stringify({ cid: cfg.cid, ts: cfg.ts, sig: cfg.sig, data: snapshot() });
    fetch(cfg.endpoint, { method: 'POST', body: payload, keepalive: payload.length < 60000,
                          headers: { 'Content-Type': 'text/plain;charset=utf-8' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.ok) {
          if (!again) { try { rawRemove.call(ls, PEND); } catch (e) { /* blocked */ } }
          if (res.meta) { meta = res.meta; write(META, meta); notify(); }
        } else if (res && res.error && window.console) {
          console.warn('[My Kitchen] ' + res.error);
        }
      })
      .catch(function () { /* offline: the pending flag keeps the change for the next page */ })
      .then(function () { inflight = false; if (again) { again = false; push(); } });
  }

  if (syncing) {
    var server = (cfg.saved && cfg.saved.data) || {};
    var local = snapshot();
    var owner = ls.getItem(OWNER);
    if (cfg.saved && cfg.saved.meta) write(META, cfg.saved.meta);
    if (owner && owner !== String(cfg.cid)) {
      // another member used this browser before: show this member's own saves, don't mix theirs in
      applyLocal(server);
      rawRemove.call(ls, PEND);
    } else if (!ls.getItem(DEVICE)) {
      // first visit on this device: keep what was saved here (as a guest) and add it to the account
      var merged = mergeAll(server, local);
      applyLocal(merged);
      if (!same(merged, server)) { rawSet.call(ls, PEND, '1'); schedulePush(); }
    } else if (ls.getItem(PEND)) {
      schedulePush();                      // changes made here that haven't reached the account yet
    } else if (!same(server, local)) {
      applyLocal(server);                  // the account is the source of truth (picks up other devices)
    }
    rawSet.call(ls, DEVICE, '1');
    rawSet.call(ls, OWNER, String(cfg.cid));
  }

  /* ---------- watch the segment scripts' saves ---------- */
  function size(v) { return v == null ? 0 : Array.isArray(v) ? v.length : typeof v === 'object' ? Object.keys(v).length : 1; }
  function parse(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function changed(k, added) {
    if (syncing) {
      try { rawSet.call(ls, PEND, '1'); } catch (e) { /* blocked */ }
      schedulePush();
    } else if (!cfg.signedIn && added && NUDGE_KEYS.indexOf(k) !== -1) {
      invite(k);
    }
    notify();
  }
  if (proto && ls) {
    proto.setItem = function (k, v) {
      var watch = this === ls && !applying && KEYS.indexOf(k) !== -1;
      var before = watch && !cfg.signedIn ? size(parse(rawGet(k))) : 0;
      var out = rawSet.apply(this, arguments);
      if (watch) changed(k, !cfg.signedIn && size(parse(v)) > before);
      return out;
    };
    proto.removeItem = function (k) {
      var out = rawRemove.apply(this, arguments);
      if (this === ls && !applying && KEYS.indexOf(k) !== -1) changed(k, false);
      return out;
    };
  }
  function rawGet(k) { try { return proto.getItem.call(ls, k); } catch (e) { return null; } }

  /* ---------- guests: after a save, invite them to join (never blocks the page) ----------
     The save has already happened in this browser. The first save of a visit opens a small card (bottom right, a
     bottom sheet on phones) with what a free account adds; it never takes focus, has no backdrop, and slides away
     when the shopper scrolls on. "Not now" or the close button snoozes the card for 3 days; while snoozed, or
     after the card has been shown this visit, a save shows a one-line note at most once per visit. */
  var SNOOZE = 'vg_join_snooze_until', SEEN = 'vg_join_seen';
  var SAVED_WHAT = { vg_blog_favs: 'Saved', vg_fm_favorites_v1: 'Market saved', vg_events_saved_v1: 'Event saved',
                     'vga-saved-v1': 'Saved', vg_products_saved_v1: 'Saved for later', vg_books_saved_v1: 'Book saved', vg_bakes_v1: 'Bake logged', vg_tools_saved_v1: 'Tool saved' };
  var ICONS = {
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    repeat: '<path d="M4 12a8 8 0 0 1 14-5.3L20 9"/><path d="M20 4v5h-5"/><path d="M20 12a8 8 0 0 1-14 5.3L4 15"/><path d="M4 20v-5h5"/>',
    play: '<circle cx="12" cy="12" r="9"/><path d="M10 8.5v7l6-3.5z"/>',
    pen: '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/>'
  };
  var PERKS = [
    ['heart', 'Your saves on every device', 'Recipes, articles, markets, events and books'],
    ['repeat', 'Reorder in one click', 'Every past order, ready to buy again'],
    ['play', 'Free Baking Academy', 'Pick up any lesson where you left off'],
    ['pen', 'Share your recipes', 'Get published on VanillaGoods with your name']
  ];
  /* Signing in (or joining) lands the shopper in My Kitchen; the page they came from is offered there as a way back. */
  function joinUrl() {
    return '/customer_authentication/login?return_to=' + encodeURIComponent(cfg.kitchen || '/pages/my-kitchen');
  }
  document.addEventListener('click', function (e) {
    if (cfg.signedIn || !e.target.closest) return;
    var a = e.target.closest('a[href*="customer_authentication/login"], a[href*="/account/login"]');
    if (!a || location.pathname.indexOf(cfg.kitchen || '/pages/my-kitchen') === 0) return;
    session('vg_join_from', JSON.stringify({ u: location.pathname + location.search, t: document.title.split(/ [\u2013|-] /)[0] }));
  }, true);
  function session(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return '1'; } return null; }
  function snoozed() { var t = Number(rawGet(SNOOZE) || 0); return t && t > Date.now(); }
  function track(action, k) { try { if (typeof window.gtag === 'function') window.gtag('event', 'join_prompt', { prompt_action: action, saved_list: k || '' }); } catch (e) { /* no analytics */ } }
  function invite(k) {
    if (location.pathname.indexOf(cfg.kitchen || '/pages/my-kitchen') === 0) return;   // My Kitchen explains this already
    if (document.querySelector('.vgj')) return;
    if (!snoozed() && !session(SEEN)) { session(SEEN, '1'); setTimeout(function () { showCard(k); }, 450); return; }
    if (!session(SEEN + '_note')) { session(SEEN + '_note', '1'); setTimeout(function () { showNote(k); }, 350); }
  }
  function css() {
    if (document.getElementById('vgj-css')) return;
    var st = document.createElement('style');
    st.id = 'vgj-css';
    st.textContent = [
      '.vgj{position:fixed;z-index:2147483000;right:20px;bottom:calc(env(safe-area-inset-bottom,0px) + 20px);width:min(370px,calc(100vw - 24px));box-sizing:border-box;',
      'background:#fffdf9;color:#2f2118;border:1px solid #e6dccd;border-radius:16px;box-shadow:0 18px 44px rgba(47,33,24,.22),0 2px 6px rgba(47,33,24,.08);',
      'font-family:inherit;font-size:14px;line-height:1.45;letter-spacing:normal;text-align:left;overflow:hidden;animation:vgj-in .26s ease-out}',
      '.vgj *{box-sizing:border-box}',
      '.vgj-top{background:#2f2118;color:#fffdf9;padding:16px 48px 16px 18px;position:relative}',
      '.vgj-eyebrow{display:flex;align-items:center;gap:6px;margin:0 0 4px;font-size:11.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#d9a845}',
      '.vgj-eyebrow svg{width:14px;height:14px;fill:#d9a845;stroke:#d9a845;stroke-width:1.6}',
      '.vgj h2{margin:0;font-family:inherit;font-size:18px;font-weight:700;line-height:1.25;letter-spacing:normal;color:#fffdf9;text-wrap:balance}',
      '.vgj-x{position:absolute;top:10px;right:10px;width:32px;height:32px;display:grid;place-items:center;border:0;border-radius:50%;background:rgba(255,255,255,.1);',
      'color:#fffdf9;font:inherit;font-size:20px;line-height:1;cursor:pointer;padding:0}',
      '.vgj-x:hover{background:rgba(255,255,255,.2)}',
      '.vgj-body{padding:14px 18px 16px}',
      '.vgj-lead{margin:0 0 12px;color:#6f6257;font-size:13.5px}',
      '.vgj ul{list-style:none;margin:0 0 14px;padding:0;display:grid;gap:10px}',
      '.vgj li{display:flex;gap:10px;align-items:flex-start;margin:0}',
      '.vgj li svg{flex:none;width:30px;height:30px;padding:6px;border-radius:9px;background:#f7f1e8;fill:none;stroke:#5c4033;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}',
      '.vgj li strong{display:block;font-size:13.5px;font-weight:700;color:#2f2118}',
      '.vgj li span{display:block;font-size:12.5px;color:#6f6257}',
      '.vgj-acts{display:flex;align-items:center;gap:14px;flex-wrap:wrap}',
      '.vgj-join{display:inline-flex;align-items:center;justify-content:center;padding:10px 18px;border-radius:999px;background:#2f2118;color:#fffdf9!important;',
      'font-size:14px;font-weight:700;text-decoration:none!important;flex:1;min-width:150px}',
      '.vgj-join:hover{background:#5c4033}',
      '.vgj-later{background:none;border:0;padding:4px 0;font:inherit;font-size:13px;font-weight:600;color:#6f6257;text-decoration:underline;cursor:pointer}',
      '.vgj-member{margin:10px 0 0;font-size:12.5px;color:#6f6257}',
      '.vgj-member a{color:#5c4033!important;font-weight:700}',
      '.vgj a:focus-visible,.vgj button:focus-visible{outline:2px solid #c9962e;outline-offset:2px}',
      '.vgj.is-out{animation:vgj-out .2s ease-in forwards}',
      '.vgj-note{display:flex;align-items:center;gap:10px 14px;flex-wrap:wrap;right:auto;left:50%;transform:translateX(-50%);width:auto;max-width:calc(100vw - 24px);',
      'padding:11px 12px 11px 16px;background:#2f2118;color:#fffdf9;border-color:#2f2118;border-radius:999px;animation:vgj-note .22s ease-out}',
      '.vgj-note span{color:rgba(255,253,249,.85)}',
      '.vgj-note a{color:#2f2118!important;background:#d9a845;padding:6px 12px;border-radius:999px;font-weight:700;text-decoration:none!important;white-space:nowrap}',
      '.vgj-note .vgj-x{position:static;width:26px;height:26px;font-size:17px}',
      '@keyframes vgj-in{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}',
      '@keyframes vgj-out{to{opacity:0;transform:translateY(16px)}}',
      '@keyframes vgj-note{from{opacity:0;transform:translate(-50%,12px)}to{opacity:1;transform:translateX(-50%)}}',
      '@media (max-width:599px){.vgj{right:12px;left:12px;width:auto;bottom:calc(env(safe-area-inset-bottom,0px) + 12px)}',
      '.vgj ul{grid-template-columns:1fr 1fr;gap:10px 12px}.vgj li span{display:none}.vgj-lead{display:none}.vgj-top{padding:14px 46px 14px 16px}.vgj-body{padding:12px 16px 14px}',
      '.vgj-note{left:12px;right:12px;transform:none;border-radius:14px;animation:vgj-in .22s ease-out}}',
      '@media (prefers-reduced-motion:reduce){.vgj,.vgj.is-out,.vgj-note{animation:none}}'
    ].join('');
    document.head.appendChild(st);
  }
  function svg(name) { return '<svg aria-hidden="true" viewBox="0 0 24 24">' + ICONS[name] + '</svg>'; }
  function close(box, how, k) {
    if (!box.parentNode) return;
    document.removeEventListener('keydown', box._esc);
    window.removeEventListener('scroll', box._scroll);
    if (how === 'snooze') { try { rawSet.call(ls, SNOOZE, String(Date.now() + 3 * 86400000)); } catch (e) { /* blocked */ } }
    if (how === 'snooze' || how === 'dismiss' || how === 'scroll') track(how === 'scroll' ? 'scrolled_away' : how, k);
    box.classList.add('is-out');
    setTimeout(function () { if (box.parentNode) box.remove(); }, 220);
  }
  function wire(box, k, snoozeOnClose) {
    box._esc = function (e) { if (e.key === 'Escape') close(box, snoozeOnClose ? 'snooze' : 'dismiss', k); };
    var y0 = window.scrollY;
    box._scroll = function () { if (Math.abs(window.scrollY - y0) > 700) close(box, 'scroll', k); };
    document.addEventListener('keydown', box._esc);
    window.addEventListener('scroll', box._scroll, { passive: true });
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-vgj-close]')) close(box, snoozeOnClose ? 'snooze' : 'dismiss', k);
      else if (e.target.closest('[data-vgj-later]')) close(box, 'snooze', k);
      else if (e.target.closest('[data-vgj-join]')) track(e.target.closest('[data-vgj-join]').getAttribute('data-vgj-join'), k);
    });
    document.body.appendChild(box);
  }
  function showCard(k) {
    css();
    var box = document.createElement('div');
    box.className = 'vgj';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'false');
    box.setAttribute('aria-labelledby', 'vgj-title');
    box.innerHTML = '<div class="vgj-top"><p class="vgj-eyebrow">' + svg('heart') + '<span data-vgj-what></span></p>' +
      '<h2 id="vgj-title">Sign up free to keep it in My Kitchen</h2>' +
      '<button type="button" class="vgj-x" data-vgj-close aria-label="Close">&times;</button></div>' +
      '<div class="vgj-body"><p class="vgj-lead">Right now your saves live only in this browser. A free account keeps them safe and adds:</p><ul>' +
      PERKS.map(function (p) { return '<li>' + svg(p[0]) + '<div><strong>' + p[1] + '</strong><span>' + p[2] + '</span></div></li>'; }).join('') +
      '</ul><div class="vgj-acts"><a class="vgj-join" data-vgj-join="join" href="' + joinUrl() + '">Join free</a>' +
      '<button type="button" class="vgj-later" data-vgj-later>Not now</button></div>' +
      '<p class="vgj-member">Already a member? <a data-vgj-join="sign_in" href="' + joinUrl() + '">Sign in</a> and this save comes with you.</p></div>';
    box.querySelector('[data-vgj-what]').textContent = (SAVED_WHAT[k] || 'Saved') + ' on this device';
    wire(box, k, true);
    track('shown', k);
  }
  function showNote(k) {
    css();
    var box = document.createElement('div');
    box.className = 'vgj vgj-note';
    box.setAttribute('role', 'status');
    box.innerHTML = '<span data-vgj-what></span><a data-vgj-join="note_join" href="' + joinUrl() + '">Join free</a>' +
      '<button type="button" class="vgj-x" data-vgj-close aria-label="Close">&times;</button>';
    box.querySelector('[data-vgj-what]').textContent = (SAVED_WHAT[k] || 'Saved') + ' on this device. Join to keep it everywhere.';
    wire(box, k, false);
    setTimeout(function () { close(box, 'timeout', k); }, 7000);
  }

  /* ---------- Save buttons on every segment ----------
     Each kind writes the same list the segment's own page uses, so a heart on a listing and the heart on the
     item's page always agree. Lists are arrays of ids or objects keyed by id. */
  var SAVERS = [
    { attr: 'data-vg-save-product', key: PRODUCTS, on: 'Saved for later', off: 'Save for later', event: 'save_for_later',
      info: function (b) { return { n: b.getAttribute('data-title') || '', u: b.getAttribute('data-url') || '', t: Date.now() }; } },
    { attr: 'data-vg-save-book', key: BOOKS, on: 'Saved to My Kitchen', off: 'Save to My Kitchen', event: 'save_book',
      info: function (b) { return { n: b.getAttribute('data-title') || '', by: b.getAttribute('data-by') || '', c: b.getAttribute('data-cover') || '',
                                    u: b.getAttribute('data-url') || '', from: b.getAttribute('data-from') || '', t: Date.now() }; } },
    { attr: 'data-vg-save-recipe', key: 'vg_blog_favs', array: true, on: 'Saved', off: 'Save', event: 'recipe_favorite' },
    { attr: 'data-vg-save-market', key: 'vg_fm_favorites_v1', on: 'Saved', off: 'Save', event: 'market_favorite',
      info: function (b) {
        var lat = parseFloat(b.getAttribute('data-lat')), lng = parseFloat(b.getAttribute('data-lng'));
        return { name: b.getAttribute('data-title') || '', url: b.getAttribute('data-url') || '', city: b.getAttribute('data-city') || '',
                 state: b.getAttribute('data-state') || '', lat: isNaN(lat) ? null : lat, lng: isNaN(lng) ? null : lng, saved: new Date().toISOString() };
      } },
    { attr: 'data-vg-save-course', key: 'vga-saved-v1', prefix: 'course:', on: 'Saved', off: 'Save course', event: 'academy_save',
      info: function (b) { return { kind: 'course', title: b.getAttribute('data-title') || '', url: b.getAttribute('data-url') || '',
                                    sub: b.getAttribute('data-sub') || '', t: Date.now() }; } }
  ];
  function isOn(sv, saved, id) {
    if (sv.array) return (saved || []).map(String).indexOf(String(id)) !== -1;
    return Object.prototype.hasOwnProperty.call(saved || {}, (sv.prefix || '') + id);
  }
  function paintSaves() {
    SAVERS.forEach(function (sv) {
      var els = document.querySelectorAll('[' + sv.attr + ']');
      if (!els.length) return;
      var saved = read(sv.key) || (sv.array ? [] : {});
      els.forEach(function (b) {
        var on = isOn(sv, saved, b.getAttribute(sv.attr));
        if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var l = b.querySelector('[data-label]');
        var want = on ? sv.on : sv.off;
        if (l) { if (l.textContent !== want) l.textContent = want; }
        else if (b.getAttribute('data-title')) b.setAttribute('aria-label', (on ? 'Saved: ' : 'Save ') + b.getAttribute('data-title'));
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    SAVERS.forEach(function (sv) {
      var b = e.target.closest('[' + sv.attr + ']');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var id = b.getAttribute(sv.attr), saved = read(sv.key) || (sv.array ? [] : {}), adding = !isOn(sv, saved, id);
      if (sv.array) {
        saved = saved.map(String).filter(function (x) { return x !== String(id); });
        if (adding) saved.push(String(id));
      } else if (adding) {
        saved[(sv.prefix || '') + id] = sv.info(b);
      } else {
        delete saved[(sv.prefix || '') + id];
      }
      try { window.localStorage.setItem(sv.key, JSON.stringify(saved)); } catch (err) { /* blocked */ }
      paintSaves();
      try { if (typeof window.gtag === 'function') window.gtag('event', sv.event, { item: id, saved: adding }); } catch (err) { /* no analytics */ }
    });
  }, true);
  listeners.push(paintSaves);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintSaves); else paintSaves();
  // lists drawn by scripts (recipe search, article search, Academy filters) get their hearts painted as they appear
  // Only react when new nodes carry save buttons: other scripts (analytics, reviews, sliders) change the page constantly,
  // and repainting on each of those cost ~2 s of CPU on a throttled phone (Lighthouse, Oct 2026).
  if (window.MutationObserver) {
    var queued = false, SAVE_SEL = SAVERS.map(function (sv) { return '[' + sv.attr + ']'; }).join(',');
    var hasSaver = function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches(SAVE_SEL) || n.querySelector(SAVE_SEL))) return true;
        }
      }
      return false;
    };
    new MutationObserver(function (records) {
      if (queued || !hasSaver(records)) return;
      queued = true;
      setTimeout(function () { queued = false; paintSaves(); }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- invite links (?ref=<code>): remember who invited this shopper until they join ---------- */
  var REF = 'vg_ref';
  (function () {
    var m = /[?&]ref=([0-9a-f]{10})(?:&|$)/i.exec(location.search);
    if (!m || !ls) return;
    var code = m[1].toLowerCase();
    if (code === cfg.ref || rawGet(REF)) return;          // their own link, or someone invited them first
    try { rawSet.call(ls, REF, code); } catch (e) { /* blocked */ }
    try { if (typeof window.gtag === 'function') window.gtag('event', 'invite_landing', { ref: code }); } catch (e) { /* no analytics */ }
  })();
  if (!cfg.signedIn && rawGet(REF)) {
    var invited = function () {
      var eb = document.querySelector('.mk-guest .mk-eyebrow');
      if (eb) eb.textContent = 'A friend invited you';
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', invited); else invited();
  }

  window.vgMe = {
    signedIn: !!cfg.signedIn, syncing: syncing, keys: KEYS, kitchen: cfg.kitchen || '/pages/my-kitchen',
    ref: cfg.ref || '', first: cfg.first || '', api: Number(cfg.api) || 0,
    invitedBy: function () { var c = rawGet(REF); return c && c !== cfg.ref ? c : ''; },
    read: read, meta: function () { return meta; },
    set: function (k, v) { if (KEYS.indexOf(k) === -1) return; try { if (empty(v)) window.localStorage.removeItem(k); else window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* blocked */ } },
    onChange: function (fn) { listeners.push(fn); },
    syncNow: push,
    activity: function () { return cfg.activity || {}; },
    profile: function () { return cfg.profile || {}; },
    /* recipe submissions and profile changes go straight to the sync service; resolves with its answer */
    send: function (action, body) {
      if (!syncing) return Promise.resolve({ ok: false, error: 'Please sign in first.' });
      var payload = { cid: cfg.cid, ts: cfg.ts, sig: cfg.sig, action: action };
      Object.keys(body || {}).forEach(function (k) { payload[k] = body[k]; });
      return fetch(cfg.endpoint, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'text/plain;charset=utf-8' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.ok) {
            if (res.activity) cfg.activity = res.activity;
            if (res.profile) cfg.profile = res.profile;
          }
          return res;
        })
        .catch(function () { return { ok: false, error: 'Could not reach VanillaGoods. Check your connection and try again.' }; });
    }
  };
})();
